import { Button, Flex, Separator, Skeleton } from "@radix-ui/themes";
import { FieldGroup } from "@/v2/components/fields/field-group/FieldGroup";
import { Step } from "./Step";

interface SampleFormSkeletonProps {
  submitLabel?: string;
}

export function SampleFormSkeleton({
  submitLabel = "Create Scorecard",
}: SampleFormSkeletonProps) {
  return (
    <Flex p={"6"} direction={"column"} gap={"8"}>
      <FieldGroup label="Scorecard Name" noSeparator>
        <Skeleton className="w-full h-[64px]" />
      </FieldGroup>

      <Step index={1} label="Target" description="Pick interactions to score">
        <Skeleton className="w-full h-[68px]" />
      </Step>

      <Separator orientation="horizontal" size="4" />

      <Step
        index={2}
        label="Evaluate"
        description="Add evaluation questions
"
      >
        <Skeleton className="w-full h-[220px]" />
      </Step>

      <Separator orientation="horizontal" size="4" />

      <Step index={3} label="Validate" description="Set review logic">
        <Skeleton className="w-full h-[220px]" />
      </Step>

      <Flex justify={"end"}>
        <Button variant="solid" color="gray" size="2" highContrast disabled>
          {submitLabel}
        </Button>
      </Flex>
    </Flex>
  );
}
